import styled from 'styled-components';

// @TODO: That nesting ain't pretty...

const Wrapper = styled.div`
  align-items: center;
  align-self: center;
  border: ${props => (props.border && '2px solid #8AEBF1')};
  background: ${props => (!props.border && props.color)};
  cursor: pointer;
  display: flex;
  font-size: 1.6rem;
  height: 4.5rem;
  justify-content: space-between;
  margin: ${props => (props.noMargin ? '0' : (props.marginAuto ? 'auto' : '2rem ' + props.rightMargin ? '2rem ' : 0 + '2rem 0'))};
  margin-left: ${props => (props.leftMargin ? props.leftMargin : '')};
  padding: 0 2rem;
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  opacity: ${props => (props.disabled ? 0.75 : 1)};
  width: ${props => `${props.width}rem`};
  .caption {
    color: ${props => (props.border ? '#8AEBF1' : '#35447d')};
    font-weight: 600;
    margin: 0;
  }
  img {
    width: 1.7em;
    height: 1.7em;
  }
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./src/components/RectButton/Wrapper.js